export default "__VITE_ASSET__CYgnftCX__"